/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ account: NonNullable<unknown> }} Notice_Slots_ViewedInputs */

const en_notice_slots_viewed = /** @type {(inputs: Notice_Slots_ViewedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.account} looked at the times`)
};

/**
* | output |
* | --- |
* | "{account} looked at the times" |
*
* @param {Notice_Slots_ViewedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const notice_slots_viewed = /** @type {((inputs: Notice_Slots_ViewedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notice_Slots_ViewedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notice_slots_viewed(inputs)
});